import {DOCUMENT, isPlatformBrowser} from '@angular/common';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {windowFixtureFactory} from '@fixtures/window';

/**
 * Service to provide a reference to the global window object,
 * safely returning a mock object when not in a browser context.
 */
@Injectable({
  providedIn: 'root',
})
export class WindowService {
  _window: Window & typeof globalThis;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    @Inject(PLATFORM_ID) private readonly platformId: Object,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this._window = this.document.defaultView;
    } else {
      // For SSR, return a fake window-like object.
      this._window = windowFixtureFactory() as unknown as Window & typeof globalThis;
    }
  }

  get window(): Window & typeof globalThis {
    return this._window;
  }
}
